import { styled } from 'styled-components';
import propTrackSvg from '../../assets/proptrack.svg';
import { spacingHelper } from '@property.com.au/ui-kit';

export const ProptrackLogoBrickSource = styled.img.attrs(
  ({ src = propTrackSvg, alt = 'PropTrack logo' }) => ({
    src,
    alt,
  }),
)`
  height: 18px;
  width: 70.5px;
  flex: 0 0 70.5px;
`;

export const StyledProptrackLogoBrickSource = styled(ProptrackLogoBrickSource)`
  margin-top: ${spacingHelper('medium')};
`;
